import EnumSet from 'Services/enumSet'

interface IChatListStatus extends EnumSet {
  none: number
  waiting: number
  available: number
  unavailable: number
  failed: number
}

const chatListStatus = new EnumSet({
  none: { value: 0, description: 'Indefinido' },
  waiting: { value: 1, description: 'Conectando, aguarde...' },
  available: { value: 2, description: 'Conectado' },
  unavailable: { value: 3, description: 'Recusou seu pedido' },
  failed: { value: 4, description: 'Perdeu o prazo' },
}) as IChatListStatus

export default chatListStatus